<a href="{{ link }}">
    <div class="heading">
        <fa-icon [icon]="icon"></fa-icon>
        <h6 class="title">{{ title }}</h6>

    </div>
    <p class="text" *ngIf="text">{{ text }}</p>
</a>